import { ProductReviewsFilteredData } from "./ProductReviewsFilteredData";

export class SfProductReviewsJsonStruct  {
    constructor(storeFrontId: number, productId: number, isRestricted: boolean, avgReviewScore: number, totReviews: number) {
        this.STORE_FRONT_ID = storeFrontId;
        this.PRODUCT_ID = productId;
        this.IsRestrictedSite = isRestricted;
        this.AVERAGE_REVIEW_SCORE = avgReviewScore;
        this.TOTAL_REVIEWS = totReviews;
        this.ProdReviewsRequest = new SfProductReviewsRequest(this.PRODUCT_ID, this.STORE_FRONT_ID, this.IsRestrictedSite, new ProductReviewsPage(1));
        if (this.TOTAL_REVIEWS > 0) {
            this.HasReviews = true;
        }
    }
    PRODUCT_ID: number;
    STORE_FRONT_ID: number;
    IsRestrictedSite: boolean;
    AVERAGE_REVIEW_SCORE: number;
    TOTAL_REVIEWS: number;
    HasReviews: boolean;
    ReviewsDataLoaded: boolean = false

    ProdReviewsRequest: SfProductReviewsRequest;
    ReviewsFilteredData: ProductReviewsFilteredData | undefined;
    CurrentSelectedPage: ProductReviewsPage | undefined;

    private _prodReviewPages: ProductReviewsPage[] | undefined;

    public get ProdReviewsPages(): ProductReviewsPage[] {

        if (this._prodReviewPages == undefined) {
            let totPages: number = this.PagesCount;
            if (this.TOTAL_REVIEWS > 0) {
                this._prodReviewPages = Array<ProductReviewsPage>(totPages);  //ProductReviesPages[totPages];
                for (let i: number = 0; i < totPages; i++) {
                    //this._prodReviewPages[i].PageId = i + 1;
                    this._prodReviewPages[i] = new ProductReviewsPage(i + 1);
                }
            }
        }

        return this._prodReviewPages;
    }

    public set ProdReviewsPages(value: ProductReviewsPage[]) {
        this._prodReviewPages = value;
    }


    private _reviewsPerPage: number = 4;
    public get ReviewsPerPage(): number {
        return this._reviewsPerPage;
    }

    public set ReviewsPerPage(value: number) {
        if (value !== undefined && value > 4) {
            this._reviewsPerPage = value;
            this._pages = 0;
        } else {
            this._reviewsPerPage = 4;
        }
    }

    private _pages: number | undefined;

    public get PagesCount(): number {
        if ((this._pages == undefined || this._pages == 0) && this.TOTAL_REVIEWS > this.ReviewsPerPage) {
            this._pages = Math.ceil(this.TOTAL_REVIEWS / this.ReviewsPerPage);
        } else {
            this._pages = 1;
        }

        return this._pages;
    }


}

export class ProductReviewsPage {
    constructor(private pgId: number) {
        this.PageId = pgId;
    }
    PageId: number;
}

export class ProductReviewsSorting {
    SortId: number;
    SortTextUiFormatted: string;
}

export class SfProductReviewsRequest {

    constructor(pid: number, sfid: number, isRestricted: boolean, currPage: ProductReviewsPage) {
        this.productid = pid;
        this.storefrontid = sfid;
        this.isrestricted = isRestricted;
        this.CurrentPageSelected = currPage;
    }
    productid: number;
    storefrontid: number;
    isrestricted: boolean;
    rowForm: number = 0;
    rowTo: number = 3;
    mostRecent: boolean = false;
    ReviewsPerPage: number = 4;
    CurrentPageSelected: ProductReviewsPage;
}

export class ProductReviewVoteRequest {
    constructor(rid: number, sfcid: number) {
        this.reviewId = rid;
        this.sfCustomerId = sfcid;
    }
    reviewId: number;
    sfCustomerId: number;
}